import React from 'react';

import LinkMui from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const LinksCellRenderer = ({ value }) => {
  const items = Array.isArray(value) ? value : [];

  return (
    <>
      {items.map(({ referenceNumber, documentUrl }, index) => (
        <span key={referenceNumber}>
          <LinkMui
            href={documentUrl}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
          >
            {referenceNumber}
            <OpenInNewIcon sx={{ fontSize: 16 }} />
          </LinkMui>
          {index < items.length - 1 && ', '}
        </span>
      ))}
    </>
  );
};

export default LinksCellRenderer;
